export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/pinanyiliao-3d7f71d62076481ba7505eacbbe7fd7f.png";